import { render, staticRenderFns } from "./postList.vue?vue&type=template&id=24692241&scoped=true"
import script from "./postList?vue&type=script&lang=js&external"
export * from "./postList?vue&type=script&lang=js&external"
import style0 from "./postList.vue?vue&type=style&index=0&id=24692241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24692241",
  null
  
)

export default component.exports